import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EventScrollableList from '../../../pages/History/CardDetailsPanel/EventSection/EventScrollableList';
import { strings } from '../../../localization';

// NOTE: This is very similar to the EventSection object in the History Page.
// Changes here should also be reflected in that object
export default class EventSection extends PureComponent {

    render() {
        const closeEventMediaButton = this.props.selectedEvent ? (
            <button className="btn btn-outline-blue btn-sm btn-close-event" onClick={(e) => this.props.onSelectEvent(null)}>
                <i className="material-icons">close</i>{strings.formatString(strings.db_close_event_media)}
            </button>
        ) : null;

        return (
            <div className="col-12 event-panel" id={this.props.id}>
                <div className="row section-wrapper">
                    <div className="col-12 section-header">
                        <h3>{strings.events_title}</h3>
                        {closeEventMediaButton}
                        {/* RAV-4031
                        <button className="btn btn-outline-blue btn-sm btn-close-event" onClick={this.props.toggleEnhancedVideoAccessModeActive}>
                            <i className="material-icons">play_circle_outline</i> {strings.vehicle_details_request_video}
                        </button>
                        */}
                        <button className="btn btn-outline-blue btn-sm btn-close-event" onClick={this.props.print}>
                            <i className="material-icons">print</i> {strings.action_summary}
                        </button>

                    </div>
                    <div className="col-12 section-body">
                        <EventScrollableList
                            ravenUuid={this.props.ravenUuid}
                            events={this.props.events}
                            card={this.props.card} /* for segments, speedZones, drivers */
                            allSupportedEvents={this.props.allSupportedEvents}
                            selectedEvent={this.props.selectedEvent}
                            onSelectEvent={this.props.onSelectEvent}
                            mediaRequestType={this.props.mediaRequestType}
                            unitOfMeasure={this.props.unitOfMeasure}
                            renderForDashboard={true}
                        />
                    </div>
                    <div className="section-btns">
                        {closeEventMediaButton}
                    </div>
                </div>
            </div>
        );
    }
}

EventSection.propTypes = {
    unitOfMeasure: PropTypes.oneOf(['METRIC','IMPERIAL']).isRequired,
};
